import styled, { css } from 'styled-components';

import WaveSVG from 'Public/graphics/waves/promo-point/solent-story/solent-story-wave.svg';

export const Inner = styled.div`
    ${({ theme }) => css`
        color: ${theme.colors.accents[10].hex};
    `}
`;

export const WaveWrapper = styled.div`
    position: absolute;
    overflow: hidden;
    inset: 0;
`;

export const Wave = styled(WaveSVG)`
    ${({ theme }) => css`
        position: absolute;
        top: 0;
        left: 0;
        width: 35.5rem;
        fill: ${theme.colors.secondary.tints[1].hex};
    `}
`;
